import { useState } from 'react';

import { Button } from '@/ui';
import { track } from '@/utils';

import Modal from './Modal';

import type { FC } from 'react';

interface UploadProps {
  disabled?: boolean;
  maxDocumentsReached?: boolean;
}

const Upload: FC<UploadProps> = ({
  disabled = false,
  maxDocumentsReached = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const isDisabled = disabled || maxDocumentsReached;

  const onOpen = () => {
    if (isDisabled) return;
    track('Clicked Upload File');
    setIsOpen(true);
  };

  const onClose = () => setIsOpen(false);

  return (
    <>
      <Button
        className="w-full md:w-fit"
        disabled={isDisabled}
        variant="outlined"
        onClick={onOpen}
      >
        Upload
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default Upload;
